module.exports = __webpack_public_path__ + "static/media/louis3.452ed9c2.mp3";